import { langTypes } from 'config/langType';
export const basicFonts = [
    'Roboto',
    'PingFang TC',
    'Helvetica',
    'Arial',
    'Lato',
    'Noto Sans TC',
    'Noto Sans CJK TC',
    'Source Han Sans TC',
    'Microsoft JhengHei',
    '微軟正黑體',
    'Microsoft YaHei',
    'Droid Sans',
    'Hiragino Sans GB',
    'sans-serif'
];

export const generateFontFamily = lang => {
    if (lang === langTypes.JA_JP) {
        const extendedFont = ['Noto Sans JP', ...basicFonts];
        return extendedFont.map(font => `'${font}'`).join(',');
    }
    if ([langTypes.ZH_TW, langTypes.ZH_HK, langTypes.ZH_CN].includes(lang)) {
        const extendedFont = ['Noto Sans TC', 'Noto Sans CJK TC', ...basicFonts];
        return extendedFont.map(font => `'${font}'`).join(',');
    }
    return basicFonts.map(font => `'${font}'`).join(',');
};
